import {OutstandingCharges} from './OutstandingCharges';
export default OutstandingCharges;